import type { ProjectSlug } from './projects';

export interface HistoryEntry {
    year: number;
    projects: ProjectSlug[];
}

export const history: HistoryEntry[] = [
    { year: 2023, projects: ['johannes-brenz'] },
    { year: 2024, projects: ['launchx'] },
    { year: 2025, projects: ['lunascope', 'auroraspotter'] },
    { year: 2026, projects: ['sunup', 'slingpin', 'freifenster', 'design'] }
];
